import type InvoiceAdjustment from '~/types/InvoiceAdjustment';

import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';
import { getFailed, getNotRequested, getRequesting, getSuccess } from '~/utils/fetchable';

export type InvoiceAdjustmentsState = {
  readonly displayInvoiceAdjustments: Requestable<InvoiceAdjustment[], string>;
};

const initialState: InvoiceAdjustmentsState = {
  displayInvoiceAdjustments: getNotRequested(),
};

const invoiceAdjustmentsReducer = (
  state: InvoiceAdjustmentsState = initialState,
  action: ActionTypes,
): InvoiceAdjustmentsState => {
  switch (action.type) {
    case ActionKeys.DISPLAY_INVOICE_ADJUSTMENTS_FETCH:
      return {
        ...state,
        displayInvoiceAdjustments: getRequesting(),
      };
    case ActionKeys.DISPLAY_INVOICE_ADJUSTMENTS_FETCH_SUCCESS:
      return {
        ...state,
        displayInvoiceAdjustments: getSuccess(action.payload.invoiceAdjustments),
      };
    case ActionKeys.DISPLAY_INVOICE_ADJUSTMENTS_FETCH_ERROR:
      return {
        ...state,
        displayInvoiceAdjustments: getFailed(action.payload.err),
      };
    default:
      return state;
  }
};

export default invoiceAdjustmentsReducer;
